/** Корень приложения survey-client (плейсхолдер до экрана опроса). */
export const ROUTE_HOME = '/';

/** Форма регистрационного опроса (авторизованная зона). */
export const ROUTE_REGISTRATION_SURVEY = '/registration-survey';

/** Страница общей ошибки (без бизнес-логики обработки сбоев). */
export const ROUTE_SOMETHING_WENT_WRONG = '/error';

/** Страница выхода из сессии Keycloak. */
export const ROUTE_LOGOUT = '/logout';
